import wrapWithProvider from './wrap-with-provider'
import '@allied-solutions/affinity-sd/assets/fonts/stylesheet.css'
import 'react-datepicker/dist/react-datepicker.css'
import 'wicg-inert/dist/inert'
import { navigate } from 'gatsby'
import { captureCiamOAuthCallback } from './src/hooks/useCiamAuthorize'

export const wrapRootElement = wrapWithProvider

export const onClientEntry = () => {
  captureCiamOAuthCallback()
}

export const onRouteUpdate = ({ location }) => {
  if (
    location.pathname === '/agent' ||
    location.pathname === '/default.aspx' ||
    location.pathname === '/account/'
  ) {
    navigate('/')
  }
}
